import { FaEye, FaRegEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonIcon from "components/ButtonIcon";
import FormSearch from "components/FormSearch";
import TableComponent from "components/Table";
import { StaffWrapper } from "./styled"
import { authSelector, staffSelector } from 'redux/selector'
import { staffActions } from 'redux/slice/staffSlice'
import useDebounce from 'hooks/useDebounce'
import AdminModalEditAccount from "../components/AdminModalEditAccount"
import Loading from "components/Loading";
import { role } from "common/general";

const Staff = () => {
    document.title = 'Quản lý nhân viên'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()
    const authState = useSelector(authSelector)

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const [permission, setPermission] = useState('all')
    const [queryInput, setQueryInput] = useState('')
    const staffState = useSelector(staffSelector)
    const dispatch = useDispatch()
    const querySearch = useDebounce(queryInput, 500)
    const [method, setMethod] = useState('add')
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)
    const typeModal = 'staff'

    useEffect(() => {
        dispatch(staffActions.getStaff({ query: querySearch, permission: permission, currentPage: currentPage }))
    }, [querySearch, permission, currentPage, dispatch])

    const handleChangePermission = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/staff?page=1`)
        }
        setPermission(e.target.value);
    }
    const handleChangeSearchInput = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/staff?page=1`)
        }
        setQueryInput(e.target.value)
    }
    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/staff?page=${pageNumber}`)
    }

    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }

    const handleShowAddModal = () => {
        setMethod('add')
        setShowModal(!showModal)
    }

    const handleShowDetailModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('show')
        setShowModal(!showModal)
    }

    const handleShowUpdateModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('update')
        setShowModal(!showModal)
    }

    const handleShowRemoveModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('remove')
        setShowModal(!showModal)
    }

    const columns = [
        {
            title: 'Mã nhân viên',
            dataIndex: 'account_id',
            key: 'account_id',
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'account_name',
            key: 'account_name',
        },
        {
            title: 'Họ và tên',
            dataIndex: 'full_name',
            key: 'full_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Điện thoại',
            dataIndex: 'phone_number',
            key: 'phone_number',
        },
        {
            title: 'Giới tính',
            key: 'sex',
            dataIndex: 'sex',
            render: (_, { sex }) => (
                // eslint-disable-next-line eqeqeq
                sex == 0 ? 'Nam' : sex == 1 ? 'Nữ' : sex == 2 ? "Khác" : ""
            ),
        },
        {
            title: 'Chức vụ',
            key: 'permission',
            dataIndex: 'permission',
            render: (_, { permission }) => (
                // eslint-disable-next-line eqeqeq
                permission == 0 ? 'Quản lý' : 'Nhân viên'
            ),
        },
        {
            title: 'Trạng thái',
            key: 'status',
            dataIndex: 'status',
            render: (_, { status }) => (
                // eslint-disable-next-line eqeqeq
                status == 0 ? 'Hoạt động' : 'Khóa'
            ),
        },
        {
            title: 'Hoạt động',
            key: 'created_at',
            dataIndex: 'created_at',
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { account_id }) => (
                <>
                    {/* <ButtonIcon
                        onClick={() => handleShowDetailModal(account_id)}
                        icon={<FaEye />}
                        description='Chi tiết'
                        classButton="action-primary btn-action"
                    /> */}
                    <ButtonIcon
                        onClick={() => handleShowUpdateModal(account_id)}
                        icon={<FaRegEdit />}
                        description='Sửa'
                        classButton="action-danger-2 btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowRemoveModal(account_id)}
                        icon={<FaTrashAlt />}
                        description='Xóa'
                        classButton="action-danger btn-action"

                    />
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + staffState.staffList.length)
        }
        else {
            setTotalItemInPage(staffState.staffList.length)
        }
    }, [currentPage, staffState.staffList.length])

    useEffect(() => {
        if (authState.role !== role.ADMIN) {
            navigate("/")
        }
    }, [authState.role, navigate])

    return (
        <StaffWrapper className="admin_staff">
            <div className="admin_staff_control py-0 px-15">
                <FormSearch
                    placeholder='Tìm kiếm nhân viên...'
                    queryInput={queryInput}
                    onChange={handleChangeSearchInput}
                    setQueryInput={setQueryInput}
                />
                <div className="admin_staff_control_sort-add">
                    <select className="mr-15 px-10" onChange={handleChangePermission}>
                        <option value='all'>Toàn bộ</option>
                        <option value='0'>Quản lý</option>
                        <option value='1'>Nhân viên</option>
                    </select>
                    <ButtonIcon
                        onClick={handleShowAddModal}
                        icon={<FaPlus />}
                        description="Thêm mới"
                        classButton="btn_add action-danger-1"
                    />
                </div>
            </div>
            <div className="admin_staff_table">
                {
                    staffState.isFetching &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={staffState.staffList}
                />
            </div>
            {
                staffState.staffList.length > 0 &&
                <div className="admin_staff_pagination mt-15 px-15">
                    <span className="admin_staff_pagination_total_item medium">
                        {totalItemInPage} / {staffState.totalItem}
                    </span>
                    {
                        staffState.totalPage > 1 &&
                        <Pagination count={staffState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }

            <AdminModalEditAccount
                typeModal={typeModal}
                selectedId={selectedId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                querySearch={querySearch}
                permission={permission}
                showModal={showModal}
                hidden={handleHiddenForm}
                method={method}
            />

        </StaffWrapper>
    );
}

export default Staff;